import { type ReactElement } from 'react';
import { type AddSubjectAreaDialogProps } from '@/types';
import { SUBJECT_AREAS_TEXT } from '@/constants/subject-area-constants';
import { SubjectAreaDialog } from './subject-area-dialog';

export const AddSubjectAreaDialog = ({
  isOpen,
  subjectAreaName,
  selectedScedCode,
  scedOptions,
  isSaving,
  isDuplicate = false,
  onSubjectAreaNameChange,
  onSelectedScedCodeChange,
  onSave,
  onClose,
}: AddSubjectAreaDialogProps): ReactElement | null => {
  return (
    <SubjectAreaDialog
      isOpen={isOpen}
      modalId="add-subject-area-modal"
      title="Add subject area"
      subjectAreaName={subjectAreaName}
      selectedScedCode={selectedScedCode}
      scedOptions={scedOptions}
      isSubmitting={isSaving}
      primaryText="Save"
      primaryButtonId="add-subject-area-modal-save"
      buttonFooterId="add-subject-area-modal-button-footer"
      cancelButtonId="add-subject-area-modal-cancel"
      nameFieldId="add-subject-area-name"
      scedFieldId="add-subject-area-sced"
      isPrimaryDisabled={isDuplicate}
      inlineErrorMessage={isDuplicate ? SUBJECT_AREAS_TEXT.DuplicateCombinationError : undefined}
      onSubjectAreaNameChange={onSubjectAreaNameChange}
      onSelectedScedCodeChange={onSelectedScedCodeChange}
      onPrimaryAction={onSave}
      onClose={onClose}
    />
  );
};
